module.exports = __webpack_public_path__ + "static/media/donbosco4.aa77313c.jpg";